module.exports = __webpack_public_path__ + "img/menu2.c1aff124.png";